"use client";

import React from "react";
import { Pill, Image, MessagesSquare, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CompassionateCareForCityPets() {
  const cards = [{
    id: "payment",
    icon: Pill,
    title: "Online Pharmacy",
    content: <ul className="text-left text-sm space-y-2 w-full list-disc pl-5 marker:text-foreground font-default">
          <li>Prescription refills</li>
          <li>Premium pet nutrition</li>
          <li>Preventative care meds</li>
          <li>Direct home delivery</li>
        </ul>,
    isRed: false
  }, {
    id: "puppies",
    icon: Image,
    title: "Patient Gallery",
    content: <Link to="/PatientGalleryPage" className="w-full">
          <Button className="bg-ring hover:bg-ring/90 text-white w-full py-6 whitespace-normal h-auto text-base font-default font-bold rounded-lg">
            View Our<br />Happy Patients
          </Button>
        </Link>,
    isRed: false
  }, {
    id: "breed-club",
    icon: MessagesSquare,
    title: "Wellness Plans",
    content: <Link to="/WellnessServicesPage" className="w-full">
          <Button className="bg-ring hover:bg-ring/90 text-white w-full py-6 whitespace-normal h-auto text-base font-default font-bold rounded-lg">
            Explore<br />Preventative<br />Care<br />Options
          </Button>
        </Link>,
    isRed: false
  }, {
    id: "contact",
    icon: PhoneCall,
    title: "Emergency Care",
    content: <div className="text-white space-y-3 w-full">
          <p className="text-xl md:text-2xl font-default font-bold">(555) 123-4567</p>
          <p className="text-lg md:text-xl font-default font-bold">Available 24/7</p>
          <p className="text-xl md:text-2xl font-default font-bold">Urgent Pet Help</p>
        </div>,
    isRed: true
  }];
  return <section data-section-id="261035" id="compassionate-care-for-city-pets" className="bg-background text-foreground w-full">
      {}
      <div className="bg-gradient-to-br from-background to-accent pt-24 pb-56 lg:pt-32 lg:pb-72 relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {}
            <div className="max-w-2xl z-20 lg:mr-12">
              <h1 className="text-5xl md:text-6xl lg:text-6xl font-default font-bold text-foreground leading-[1.1] tracking-tight">
                Compassionate Care for City Pets
              </h1>
              <p className="mt-6 text-lg md:text-xl text-muted-foreground font-default font-medium max-w-lg leading-relaxed">
                Modern veterinary excellence in the heart of the city. Trusted care for your urban companions.
              </p>
              <div className="mt-10 flex gap-4">
                <Link to="/WellnessServicesPage">
                  <Button className="bg-ring hover:bg-ring/90 text-white px-8 py-6 text-lg font-default font-bold rounded-lg shadow-lg">
                    Our Services
                  </Button>
                </Link>
                <Link to="/EmergencyPharmacyPage">
                  <Button variant="outline" className="border-ring text-ring hover:bg-ring/10 px-8 py-6 text-lg font-default font-bold rounded-lg">
                    Book Now
                  </Button>
                </Link>
              </div>
            </div>

            {}
            <div className="relative h-[400px] lg:h-[600px] w-full lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 lg:w-[50%] z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/vet_smiling_at_golden_retriever.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/vet_smiling_at_golden_retriever.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/vet_smiling_at_golden_retriever.png-wvc-sizes" alt="Veterinarian smiling at a Golden Retriever" className="object-cover object-left lg:object-center w-full h-full rounded-3xl shadow-2xl" loading="eager" />
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-30 -mt-40 lg:-mt-48 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => <div key={card.id} data-index={i} className={`rounded-lg shadow-xl p-8 flex flex-col items-center text-center transition-transform hover:-translate-y-1 duration-300 backdrop-blur-md ${card.isRed ? "bg-destructive text-destructive-foreground" : "bg-card text-card-foreground border border-border"}`}>
              <card.icon className={`w-12 h-12 mb-6 ${card.isRed ? "text-white" : "text-ring"}`} strokeWidth={2} />
              <h3 className={`font-default text-2xl font-bold mb-6 ${card.isRed ? "text-white" : "text-foreground"}`}>
                {card.title}
              </h3>
              <div className="w-full flex-grow flex flex-col justify-center">
                {card.content}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}